
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/en/legal/code",
      function () {
        return require("private-next-pages/en/legal/code.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/en/legal/code"])
      });
    }
  